import React from "react";
import moment from "moment";
import DeferredCalendarDay from "./DeferredCalendarDay";

const MonthSection = ({
  monthKey,
  monthData,
  viewMode,
  renderDay,
  onArtistSelect,
}) => {
  const sortedArtists = Object.entries(
    monthData.artists || {}
  ).sort(([artistA], [artistB]) =>
    artistA.localeCompare(artistB)
  );

  const getArtistId = (artistName) =>
    `artist-${monthKey}-${artistName}`
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9-_]/g, "");

  const scrollToArtist = (artistName) => {
    const artistId = getArtistId(artistName);

    const target =
      document.getElementById(artistId);

    if (!target) return;

    if (onArtistSelect) {
      onArtistSelect(artistName);
    }

    const stickyHeader =
      document.querySelector(
        `#month-${monthKey} .month-sticky-header`
      );

    const stickyHeight =
      stickyHeader?.offsetHeight || 0;

    const top =
      target.getBoundingClientRect().top +
      window.scrollY -
      75 -
      stickyHeight;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  return (
    <div
      id={`month-${monthKey}`}
      className="month-section"
    >
      <div className="month-sticky-header">
        <h3>{monthData.label}</h3>

        {sortedArtists.length > 1 && (
          <div className="month-artist-shortcuts">
            {sortedArtists.map(
              ([artistName, artistInfo]) => (
                <button
                  key={`shortcut-${monthKey}-${artistName}`}
                  type="button"
                  className="month-artist-shortcut"
                  onClick={() =>
                    scrollToArtist(artistName)
                  }
                >
                  {artistInfo.artistName}
                </button>
              )
            )}
          </div>
        )}
      </div>

      {sortedArtists.length === 0 && <p className="calendar-empty-month">Für diesen Monat sind keine Künstler-Tage geplant.</p>}
      {sortedArtists.map(
        ([artistName, artistInfo]) => {
          const artistId =
            getArtistId(artistName);

          return (
            <div
              id={artistId}
              key={`artist-${monthKey}-${artistName}`}
              className="artist-section"
            >
              {viewMode === "grid" && (
                <h4>
                  {artistInfo.artistName}
                </h4>
              )}

              <div
                className={
                  viewMode === "grid"
                    ? "dates-container"
                    : ""
                }
              >
                {(artistInfo.dates || [])
                  .slice()
                  .sort((a, b) =>
                    moment(a.day).diff(
                      moment(b.day)
                    )
                  )
                  .map((day) =>
                    <DeferredCalendarDay key={day.dayId} dayId={day.dayId}
                      renderDay={() => renderDay(day, artistInfo)} />
                  )}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

export default MonthSection;